import { logger } from '@/src/logging/logger';

try {
  window.addEventListener('error', (event) => {
    logger.error('Unhandled browser error', event.error ?? event.message, {
      eventType: 'error',
      filename: event.filename ? getNavigationLogPathname(event.filename) : undefined,
      lineNumber: event.lineno,
      columnNumber: event.colno,
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    logger.error('Unhandled promise rejection', event.reason, {
      eventType: 'unhandledrejection',
    });
  });
} catch (error) {
  logger.error('Failed to initialize client instrumentation', error);
}

export function getNavigationLogPathname(url: string) {
  try {
    return new URL(url, window.location.origin).pathname;
  } catch {
    return url.split(/[?#]/, 1)[0] || '/';
  }
}

export function onRouterTransitionStart(url: string, navigationType: 'push' | 'replace' | 'traverse') {
  logger.debug('Router transition started', { pathname: getNavigationLogPathname(url), navigationType });
}
